import type { RedirectProps } from 'react-router-dom'
import { Redirect } from 'react-router-dom'

export type AppRedirectProps = RedirectProps

export function AppRedirect(props: AppRedirectProps) {
  return <Redirect {...props} />
}
